import ProfileCard from "components/ProfileCard";
import React from "react";

function Instructores() {
  return (
    <div className="px-20 pb-20 bg-blue-200 flex flex-col items-center gap-10">
      <h1 className="text-4xl mt-40 ">Teachers</h1>
      <p className="w-1/2">
        Nuestro equipo está formado por profesionales experimentados y
        cualificados para guiar a nuestros estudiantes en su
        camino hacia la fluidez en inglés. Conoce a nustros educadores quienes
        te motivaran y fomentaran tu aprendizaje en Brighton Centro de Ingles.
      </p>
      <div className="grid grid-cols-4 gap-5 w-max mx-auto ">
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
        <ProfileCard name="Gabi" job="Teacher"/>
      </div>
    </div>
  );
}

export default Instructores;
